import type { EntryAction } from "../reducers/entry";

const entryActions = {
  CLEAR: "CLEAR",
  UPDATE_CHALLENGE_RESPONSE: "UPDATE_CHALLENGE_RESPONSE",
  UPDATE_EMAIL: "UPDATE_EMAIL",
  UPDATE_ERROR: "UPDATE_ERROR",

  clear(): EntryAction {
    return { type: "CLEAR" };
  },
  updateEmail(email: string): EntryAction {
    return { type: "UPDATE_EMAIL", email };
  },
  updateChallengeResponse(challengeResponse: string | null): EntryAction {
    return { type: "UPDATE_CHALLENGE_RESPONSE", challengeResponse };
  },
  updateError(error: string): EntryAction {
    return { type: "UPDATE_ERROR", error };
  },
};

export default entryActions;
